import { render, staticRenderFns } from "./Cursos.vue?vue&type=template&id=0a9cd82d&"
import script from "./Cursos.vue?vue&type=script&lang=js&"
export * from "./Cursos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports